<template>
  <zingchart :data="chartConfig" :width="800" />
</template>

<script>
  export default {
    data() {
      return {
        chartConfig: {
          graphset: [{
            type: 'bar', /* Specify your chart type. */
            title: {
              text: 'График 8 (Грузооборот по культурам)',
              align: 'left',
              marginLeft: '23%'
            },
            legend: {
              adjustLayout: true,
              verticalAlign: 'middle'
            },
            plot: {
              stacked: true,
            },
            scaleX: {
              values: ['Агрикалчер Кубань', 'Зерно-трейд', 'Агрикалчер Ростов']
            },
            scaleY: {
              values: "0:80000:10000"
            },
            series: [{
              values: [2222, 42663, 24167],
              text: 'Пшеница 4 класс',
              stack: 1,
              backgroundColor: 'yellowgreen'
            }, {
              values: [25000, 21000, null],
              text: 'Пшеница 5 класс',
              stack: 1,
              backgroundColor: 'orange'
            }, {
              values: [8000, null, null],
              text: 'Ячмень',
              stack: 1,
              backgroundColor: 'dimgray'
            }, {
              values: [null, 7000, null],
              text: 'Пшеница 3 класс',
              stack: 1,
              backgroundColor: 'dodgerblue'
            }, {
              values: [null, null, null],
              text: 'Кукуруза',
              stack: 1,
              backgroundColor: 'yellow'
            }]
          }]
        }
      }
    }
  }
</script>

<style scoped>

</style>